export interface CroppedValueStateModel {
  croppedValue: string;
  fitsOnIteration: boolean;
}

export enum ExpandableContentState {
  Opened = 'OPENED',
  Closed = 'CLOSED',
}
